const combineComponentConfig = {
    env: 'sit', //  'sit'，'uat'，'prod'  三种环境，prod是生产环境可以不写env属性
    lang: 'zh-CN', // 国际化语言：zh-CN | en-US | ja-JP
    userInfo: {
        user: '', //  mip账号
        appId: '',
        productId: 'd91a9e07-ef59-4fa6-a3f7-d674bb53cd1e', // 填写自己项目的产品id
        systemId: 'ce403cb6-6961-47f0-8b5b-6f17ad931e35', // 填写自己项目的系统id
        commonFieldList: [{
            name: '操作页面或菜单路径',
            value: '操作页面或菜单路径'
        }] // 富文本公共字段参数(可不填)，最多5个字段，提交it5000会回显到富文本中
    },
    componentBottom: 300, // 调整组件底部距离，(有默认值可以不传)
    intimeevaluateUserInfo: {
        user_name: '', // mip账号（姓名）
        user_id: '' // mip账号
    },
    intimeevaluateTempleteInfo: {
        appType: 'pc', // 终端类型 pc、app
        modeType: 'hover', // 弹框挂件展示类型 hover: 挂件式(悬浮右下角) inner:嵌入  默认:''不展示任何挂件
        business: '物流领域', // 领域 eg: 内销领域
        system: 'C-SNP', // 系统 eg: 美云销
        product: 'GWMS仓储服务产品', // 产品 eg: TPC交易与履约中心
        scene: 'C-SNP页面右侧', // 投放位置, 挂件式一般放页面右下角，eg: 人才搜索右侧
        primaryColor: '', // 提交按钮的主色调,默认：#0888ff
        hoverBtnColor: '', // 提交按钮在hover时候的颜色， 默认：#39a0ff
        hoverTagColor: '' // tag标签在hover时候的颜色 默认：#ebf5ff
    },
    tabs: [
        // 菜单名称(最多4个)
        {
            unique: 'comment',
            name: '我要评价',
            icon: 'icon-chat-line-square-filled', // 我的评价静态icon为icon-chat-line-square-filled，为空则显示动图gif
            jumpUrl: '',
            fn: {}
        },
        {
            unique: 'G5000',
            name: 'IT5000',
            icon: 'icon-tool-filled',
            jumpUrl: ''
        },
        {
            unique: 'logistics-AI',
            name: '物流AI',
            isCustom: true,
            icon: 'https://lc.midea.com/api-oss/public/oss/file/hashDownload/1726033276440_76a16e20-7000-11ef-998a-3890a5bd40fc.png',
            jumpUrl: 'https://aigc.midea.com/frontweb-iop/portal/home?forwardAgent=true&agentId=AG_Logistics_Intelligent&nosidebar=1&fromForwardAgent=true'
        },
        {
            unique: 'advice',
            name: '我要建议',
            icon: 'icon-edit-filledbeifen',
            jumpUrl: ''
        },
        {
            unique: 'help',
            name: '帮助中心',
            nameEn: 'Help center',
            nameJa: 'ヘルプセンター',
            icon: 'icon-question'
        }
    ],
    whetherTheCoexistence: true, // 我要建议与我要评价是否共存
    themeColor: '#0077ff', // 主题颜色
    tabsBackgroundColor: '#fff', // tabs背景色
    unfoldColor: '#0077ff', // 展开按钮颜色
    configInfo: {
        mode: null, // 1:GPM系统,不传和为空都是默认模式
        unfoldIcon: 'icon-edit-filled', // 展开按钮icon
        screenshotsMode: 2, // 截图插件
        version: 1,
        channelCode: 'SNPsystem'
    },
    helpInfo: {
        systemName: 'SNP',
        relateId: ''
    }
};

export const setCombineComponentConfig = ({
    userCode,
    userName,
    env,
    commonFieldList = []
}) => {
    // appid
    combineComponentConfig.userInfo.appId = env === 'prod' ? '76889415234840059ee3b14d0e205b9f' : '1d813b55da174c6bb2f164597c97177a';
    combineComponentConfig.userInfo.user = userCode;
    combineComponentConfig.userInfo.commonFieldList = commonFieldList;
    combineComponentConfig.intimeevaluateUserInfo.user_id = userCode;
    combineComponentConfig.intimeevaluateUserInfo.user_name = userName;
    combineComponentConfig.env = env;
    return combineComponentConfig;
};
